import { useLocation, useRouteMatch } from 'react-router-dom';

import {
  ACCOUNTING,
  AIRDROPS,
  BIG_WHALE,
  CASHBACK_BONUS,
  DASHBOARD,
  DISCOUNT_CODE,
  EARNINGS,
  FIRST_BUY_VIRTUAL_OFFICE,
  FLIPME_CARDS,
  FINUP_HUBS,
  HELPDESK,
  HELPDESK_QUESTION,
  HELPDESK_SUBCATEGORY,
  HELPDESK_SUPPORT,
  HODL_BONUS,
  MARKETPLACE,
  MONTLY,
  MY_HUBS,
  MY_TICKETS,
  MY_HUBS_BIG_WHALE,
  MY_HUBS_FLIPME_CARDS,
  MY_HUBS_GAMING,
  MY_HUBS_PAYMENT,
  MY_HUBS_STAKING,
  MY_HUBS_TRADING,
  MY_HUBS_TRAVEL,
  MY_TEAM,
  ORDERS,
  // GAMING,
  PAYMENT,
  POOL_BONUS,
  PRIVACY_POLICY,
  RANKING,
  RESOURCES,
  SETTINGS_ACCOUNT,
  SETTINGS_LAYOUT,
  SETTINGS_NOTIFICATIONS,
  SETTINGS_PAYMENTS,
  SETTINGS_SECURITY,
  SETTINGS_TEAM_SETTINGS,
  SETTINGS_VIRTUAL_OFFICE,
  SUPPORT_TICKETS,
  TERMS_OF_USE,
  TOP_PERFORMER_BONUS,
  TRADING,
  POWERPACKS,
  MY_HUBS_POWERPACKS,
  AKASHA,
  MY_HUBS_AKASHA,
  MANAGE_AKASHA_NODE,
  WEBINARS_MENAGMENT,
  WEBINARS,
  ORDER_ITEMS,
  ORDER_INVOICES,
  MY_TICKETS_WEBINAR_TICKETS
} from '../../../routes/routes';

interface matchHelpdeskType {
  categoryId: string;
}

interface matchHelpdeskSubcategoryType {
  id: string;
  subId: string;
}

interface matchHelpdeskQuestionType {
  id: string;
  subId: string;
  categoryId: string;
}

export const ShowHide = () => {
  const matchManageAkashaNode = useRouteMatch<{ id: string }>(
    `${MANAGE_AKASHA_NODE}/:id?`
  );

  const matchHelpdesk = useRouteMatch<matchHelpdeskType>(
    `${HELPDESK}/:categoryId?`
  );
  const matchHelpdeskSubcategory = useRouteMatch<matchHelpdeskSubcategoryType>(
    `${HELPDESK_SUBCATEGORY}/:id?/:subId?`
  );
  const matchHelpdeskQuestion = useRouteMatch<matchHelpdeskQuestionType>(
    `${HELPDESK_QUESTION}/:id?/:categoryId?/:subId?`
  );

  const matchOrderItems = useRouteMatch<{ id: string }>(`${ORDER_ITEMS}/:id?`);

  const matchOrderInvoices = useRouteMatch<{ id: string }>(
    `${ORDER_INVOICES}/:id?`
  );

  const location = useLocation().pathname;

  switch (location) {
    case MY_TEAM:
      return true;

    case ACCOUNTING:
      return true;

    case DASHBOARD:
      return true;

    case EARNINGS:
      return true;

    case SETTINGS_LAYOUT:
      return true;

    case SETTINGS_ACCOUNT:
      return true;

    case SETTINGS_SECURITY:
      return true;

    case SETTINGS_PAYMENTS:
      return true;

    case SETTINGS_NOTIFICATIONS:
      return true;

    case SETTINGS_TEAM_SETTINGS:
      return true;

    case SETTINGS_VIRTUAL_OFFICE:
      return true;

    case `${WEBINARS}`:
      return true;

    case `${WEBINARS_MENAGMENT}`:
      return true;

    case `${ORDERS}`:
      return true;

    case `${ORDER_ITEMS}/${matchOrderItems?.params?.id}`:
      return true;

    case `${ORDER_INVOICES}/${matchOrderInvoices?.params?.id}`:
      return true;

    case `${MY_HUBS}`:
      return true;

    case `${MY_HUBS_POWERPACKS}`:
      return true;

    case `${MY_HUBS_AKASHA}`:
      return true;

    case `${MY_HUBS_TRAVEL}`:
      return true;

    case `${MY_HUBS_FLIPME_CARDS}`:
      return true;

    case `${MY_HUBS_TRADING}`:
      return true;

    case `${MY_HUBS_BIG_WHALE}`:
      return true;

    case `${MY_HUBS_PAYMENT}`:
      return true;

    case `${MY_HUBS_GAMING}`:
      return true;

    case `${MY_HUBS_STAKING}`:
      return true;

    case `${MY_TICKETS}`:
      return true;

    case `${MY_TICKETS_WEBINAR_TICKETS}`:
      return true;

    case `${MANAGE_AKASHA_NODE}/${matchManageAkashaNode?.params?.id}`:
      return true;

    case `${TOP_PERFORMER_BONUS}`:
      return true;

    case `${RESOURCES}`:
      return true;

    case `${MONTLY}`:
      return true;

    case `${RANKING}`:
      return true;

    case `${POOL_BONUS}`:
      return true;

    case `${HODL_BONUS}`:
      return true;

    case `${HELPDESK}`:
      return true;

    case `${HELPDESK_SUPPORT}`:
      return true;

    case `${HELPDESK_SUBCATEGORY}`:
      return true;

    case `${HELPDESK_QUESTION}`:
      return true;

    case `${HELPDESK}/${matchHelpdesk?.params?.categoryId}`:
      return true;

    case `${HELPDESK_SUBCATEGORY}/${matchHelpdeskSubcategory?.params?.id}/${matchHelpdeskSubcategory?.params?.subId}`:
      return true;

    case `${HELPDESK_QUESTION}/${matchHelpdeskQuestion?.params?.id}`:
      return true;

    case `${HELPDESK_QUESTION}/${matchHelpdeskQuestion?.params?.id}/${matchHelpdeskQuestion?.params?.categoryId}`:
      return true;

    case `${HELPDESK_QUESTION}/${matchHelpdeskQuestion?.params?.id}/${matchHelpdeskQuestion?.params?.categoryId}/${matchHelpdeskQuestion?.params?.subId}`:
      return true;

    case `${AIRDROPS}`:
      return true;

    case `${CASHBACK_BONUS}`:
      return true;

    // case `${GAMING}`:
    //   return true;

    case `${TRADING}`:
      return true;

    case `${BIG_WHALE}`:
      return true;

    case `${DISCOUNT_CODE}`:
      return true;

    case `${PAYMENT}`:
      return true;

    case `${POWERPACKS}`:
      return true;

    case `${AKASHA}`:
      return true;

    case `${FLIPME_CARDS}`:
      return true;

    case `${FINUP_HUBS}`:
      return true;

    case `${MARKETPLACE}`:
      return true;

    case `${FIRST_BUY_VIRTUAL_OFFICE}`:
      return true;

    case `${PRIVACY_POLICY}`:
      return true;

    case `${TERMS_OF_USE}`:
      return true;

    case `${SUPPORT_TICKETS}`:
      return true;

    default:
      return false;
  }
};
